export default {
  name: 'step-up-call-list',
  created () {
    this.search()
  },
  data () {
    return {
      deadlineKey: null,
      stepupNoAnswers: ''
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('STEPUP_NOANSWER_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepupNoAnswers = res
      this.deadlinekey = this.stepupNoAnswers[0]['step_up_user_id']
    },
    keybreak: function (index) {
      if (index == 0 || this.stepupNoAnswers[index]['step_up_user_id'] != this.deadlinekey) {
        this.deadlinekey = this.stepupNoAnswers[index]['step_up_user_id']
        return true
      } else {
        return false
      }
    },
    first: function (index) {
      if (index === 0) {
        return 'border-radius: 5px 5px 0px 0px;'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/step-up-call-list.js